import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actions as authenticationActions} from '../actions/authentication'
import {actions as employeeActions} from '../actions/employee'
import {actions as staticContentActions} from '../actions/static_content'
import {actions as configurationActions} from '../actions/configuration'

import DefaultPage from './DefaultPage'
import ImpersonateUserDialog from '../layouts/v2/header/ImpersonateUserDialog'

class ImpersonateV2 extends Component {

    componentDidMount() {
        this.props.actions.employee.unload()
        this.props.actions.configuration.unload()
        this.props.actions.static_content.unload()
    }

    render() {
        return (
            <DefaultPage>
                <ImpersonateUserDialog visible={true}/>
            </DefaultPage>
        );
    }
}

const mapState = state => ({
    auth: state.auth
})
  
const mapDispatchToProps = dispatch => ({
actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
    employee: bindActionCreators(employeeActions, dispatch),
    static_content: bindActionCreators(staticContentActions, dispatch),
    configuration: bindActionCreators(configurationActions, dispatch),
}
})
  
export default connect(mapState, mapDispatchToProps)(ImpersonateV2)